module.exports = __webpack_public_path__ + "static/media/cancel.db47502b.svg";